import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./components/App";
import GlobalStyles from "./components/GlobalStyles";
import { UserProvider } from "./context/UserContext";
import { CsrfProvider } from "./context/CsrfContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installGlobalErrorHandlers } from "./services/clientErrorReporter";

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // React StrictMode renders components twice on dev server
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <CsrfProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </CsrfProvider>
      </ErrorBoundary>
      <GlobalStyles />
    </Provider>
  </React.StrictMode>,
);
